module.exports = __webpack_public_path__ + "img/reply_all.5ff5821a.svg";